import React from 'react';

import QuickStartHeader from './QuickStartHeader';
import QuickStartContent from './QuickStartContent';
import styles from './QuickStartGuide.module.scss';

export default function QuickStartGuide() {
  return (
    <div className={styles.quickStartGuide}>
      <QuickStartHeader classes={{ header: styles.headerLine }} />
      <QuickStartContent
        classes={{ card: styles.card }}
        onQuickStartActionClick={() => {
          // So sketchy... why can't all our GWT have been written to clean itself up on navigation???
          window.XM_hideGWTXBubbles();
          window.XM_hideAllGWTXDialogs?.();
        }}
      />
    </div>
  );
}

QuickStartGuide.displayName = 'QuickStartGuide';
QuickStartGuide.propTypes = {};
